import React from 'react';
import {
  Printer,
  CreditCard,
  Mail,
  FileText,
  BookOpen,
  Megaphone,
  Shirt,
  ShoppingBag,
  Briefcase,
  PenTool,
  ArrowRight
} from 'lucide-react';
import '../styles/components/Services.css';

const Services = ({ setCurrentPage }) => {
  const services = [
    {
      id: 'flex',
      title: "Flex Printing",
      description: "High-quality flex printing for hoardings, banners, and backdrops.",
      items: ["Normal & Star Flex", "Retro Flex/Vinyl", "Backlight & UV"],
      icon: <Printer className="w-8 h-8" />,
      route: 'services',
      color: 'blue'
    },
    {
      id: 'cards',
      title: "Visiting Cards",
      description: "Premium business cards that make a lasting professional impression.",
      items: ["Metal & Velvet Cards", "Textured & Matte", "Start from 300 GSM"],
      icon: <CreditCard className="w-8 h-8" />,
      route: 'cards',
      color: 'indigo'
    },
    {
      id: 'wedding',
      title: "Wedding Cards",
      description: "Elegant wedding invitations and stationary for your special day.",
      items: ["Multicolor Designs", "Screen Printing", "Custom Die Cutting"],
      icon: <Mail className="w-8 h-8" />,
      route: 'cards',
      color: 'rose'
    },
    {
      id: 'pamphlets',
      title: "Pamphlets & Flyers",
      description: "Eye-catching marketing materials to promote your business effectively.",
      items: ["Multicolor Pamphlets", "Black & White Flyers", "Custom Sizes"],
      icon: <FileText className="w-8 h-8" />,
      route: 'multicolor',
      color: 'orange'
    },
    {
      id: 'brochures',
      title: "Brochures",
      description: "Professional brochures to showcase your products and services.",
      items: ["Bi-fold & Tri-fold", "Offset Printing", "Glossy Finish"],
      icon: <BookOpen className="w-8 h-8" />,
      route: 'multicolor',
      color: 'emerald'
    },
    {
      id: 'signage',
      title: "Signage & Ads",
      description: "Impactful signage solutions for indoor and outdoor branding.",
      items: ["LED Acrylic Letters", "Canopy & Standees", "In-shop Branding"],
      icon: <Megaphone className="w-8 h-8" />,
      route: 'advertise',
      color: 'violet'
    },
    {
      id: 'garments',
      title: "Garment Printing",
      description: "Custom printing on t-shirts, caps, and uniforms.",
      items: ["T-Shirt Printing", "Cap Branding", "Fabric Tags"],
      icon: <Shirt className="w-8 h-8" />,
      route: 'garments',
      color: 'cyan'
    },
    {
      id: 'packaging',
      title: "Box & Bag Printing",
      description: "Custom packaging solutions to elevate your product presentation.",
      items: ["Sweet & Medicine Boxes", "Carry Bags", "Product Packaging"],
      icon: <ShoppingBag className="w-8 h-8" />,
      route: 'boxbag',
      color: 'amber'
    },
    {
      id: 'business',
      title: "Business Essentials",
      description: "Essential stationary including bill books, stamps, and letterheads.",
      items: ["Bill Books", "Rubber Stamps", "Letterheads"],
      icon: <Briefcase className="w-8 h-8" />,
      route: 'business',
      color: 'slate'
    },
    {
      id: 'other',
      title: "Promotional Items",
      description: "Customized gifts like pens, keyrings, and mugs for branding.",
      items: ["Pen & Keyring", "Mug Printing", "Photo Frames"],
      icon: <PenTool className="w-8 h-8" />,
      route: 'other',
      color: 'fuchsia'
    }
  ];

  const handleServiceClick = (route) => {
    if (setCurrentPage) {
      setCurrentPage(route);
      window.scrollTo(0, 0);
    }
  };

  return (
    <section className="services-section" id="services">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Our Premium Services</h2>
          <p className="section-subtitle">
            Comprehensive printing and branding solutions tailored to your business needs.
            From visiting cards to large format signage, we deliver excellence.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service) => (
            <div
              key={service.id}
              className={`service-card color-${service.color}`}
              onClick={() => handleServiceClick(service.route)}
            >
              <div className="service-icon-wrapper">
                {service.icon}
              </div>
              <div className="service-content">
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <ul className="service-features">
                  {service.items.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
                <div className="service-footer">
                  <span className="learn-more">
                    View Details <ArrowRight size={16} />
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
